import { useState, useCallback, useMemo, memo } from "react";
import { Render } from "../../../../../../../../homepage/Render";
import "./StoreFrequentlyBought.scss";
import { getPlainText, togglePackage } from "../StoreUtils/storePackageUtils";

const StoreFrequentlyBought = (props) => {
  const {
    packageData,
    selectedRelatedPackages,
    setSelectedRelatedPackages,
    setSelectedFrequentPackages,
    openFrequentBoughtDetails,
  } = props;

  const [showModal, setShowModal] = useState(false);

  const handlePackageSelection = useCallback(
    (packageId, pkg) => {
      if (
        !setSelectedRelatedPackages ||
        !setSelectedFrequentPackages ||
        !pkg ||
        !packageId
      ) {
        console.warn(
          "StoreFrequentlyBought: Missing required props or package data"
        );
        return;
      }

      if (packageData?.PackageInstallmentDetails?.is_subscribe) {
        setShowModal(true);
        return;
      }

      // Update both selectedRelatedPackages and selectedFrequentPackages
      setSelectedRelatedPackages((prev) => togglePackage(prev, pkg, packageId));
      setSelectedFrequentPackages((prev) =>
        togglePackage(prev, pkg, packageId)
      );
    },
    [packageData, setSelectedRelatedPackages, setSelectedFrequentPackages]
  );

  // Memoized effective price calculation
  const effectivePrice = useMemo(() => {
    return selectedRelatedPackages
      .reduce((sum, pkg) => {
        const amount = Number(pkg.amount) || 0;
        const discount = Number(pkg.discount) || 0;
        const priceToAdd =
          discount && discount !== 0 ? amount - discount : amount;
        return sum + priceToAdd;
      }, 0)
      .toFixed(2);
  }, [selectedRelatedPackages]);

  const relatedPackages = useMemo(() => {
    return packageData?.related_packages?.slice(0, 3) || [];
  }, [packageData]);

  if (!packageData || !relatedPackages.length) {
    return null;
  }

  return (
    <Render if={true}>
      <div className="frequently-bought-together">
        <h3>Frequently Bought Together</h3>
        <div className="buyers-animation">
          <div className="avatars">
            {relatedPackages[0]?.rel_buyers_animation?.avatars
              ?.slice(0, 5)
              .map((avatar, index) => (
                <img
                  key={index}
                  src={avatar}
                  alt={`Avatar ${index + 1}`}
                  className="avatar"
                />
              ))}
          </div>
          {getPlainText(relatedPackages[0]?.rel_buyers_animation?.text)}
        </div>
        <div className="package-cards">
          {relatedPackages.map((pkg) => {
            const isSelected = selectedRelatedPackages.some(
              (p) => p.package_id === pkg.package_id
            );
            const originalPrice = Number(pkg.amount) || 0;
            const discountValue = Number(pkg.discount) || 0;
            const discountedPrice = originalPrice - discountValue;
            const showDiscountedPrice =
              discountValue > 0 && discountedPrice !== originalPrice;
            return (
              <div
                key={pkg.package_id}
                className={`package-card ${isSelected ? "selected" : ""}`}
                onClick={() => handlePackageSelection(pkg.package_id, pkg)}
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handlePackageSelection(pkg.package_id, pkg)}
                  style={{ display: "none" }}
                />
                <img
                  src={pkg.icon || pkg.banner}
                  alt={pkg.package_name || "Package"}
                  className="package-image"
                />
                <div className="package-info">
                  <p className="package-name">
                    {pkg.package_name?.split(" ").slice(0, 7).join(" ") +
                      (pkg.package_name?.split(" ").length > 7 ? "..." : "")}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p className="price-details" style={{ marginTop: "12px" }}>
                    ₹{showDiscountedPrice ? discountedPrice : originalPrice}
                  </p>
                  {showDiscountedPrice && (
                    <p
                      className="price-details"
                      style={{
                        textDecoration: "line-through",
                        marginTop: "12px",
                      }}
                    >
                      ₹{originalPrice}
                    </p>
                  )}
                  <span
                    className="view-details"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (openFrequentBoughtDetails) {
                        openFrequentBoughtDetails(pkg);
                      } else {
                        console.warn(
                          "StoreFrequentlyBought: openFrequentBoughtDetails is not a function"
                        );
                      }
                    }}
                  >
                    View details
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        <Render if={showModal}>
          <div className="logout_modal_overlay">
            <div className="logout_modal">
              <p>This package is already purchased</p>
              <div className="logout_modal_buttons">
                <button
                  className="logout_no_btn"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Render>

        <Render if={selectedRelatedPackages.length > 0}>
          <div className="effective-price">
            <p className="effective-amount">
              Effective price ({selectedRelatedPackages.length} course(s)):
              <span className="effectiveprice">₹{effectivePrice}</span>
            </p>
          </div>
        </Render>
      </div>
    </Render>
  );
};

export default memo(StoreFrequentlyBought);
